import React from 'react';
import { Heading } from '@chakra-ui/react';

const SettingsPage = () => {
  return (
    <div>
      <Heading>Settings</Heading>
    </div>
  );
};

export default SettingsPage;
